import React from 'react'
import messages from './messages'
import FormattedWeight from 'js/components/FormattedWeight'
import { FormattedMessage } from 'react-intl'
import Slideshow, { Slides, SlideshowNav } from '../Slideshow/Slideshow'
import Slide from '../Slideshow/Slide'
import once from 'one-time'
import { trackTestimonialInteraction } from 'js/analytics'
import nikeSmallImage from 'media/nike-small.jpg'
import nathalieSmallImage from 'media/nathalie-small.jpg'
import marianneSmallImage from 'media/marianne-small.jpg'

const defaultTestimonials = [
  {
    heading: (
      <>
        <strong className="font-bold">
          -{<FormattedWeight weightInKg={4.7} />}
        </strong>{' '}
        <FormattedMessage {...messages.weeks} />
      </>
    ),
    quote: <FormattedMessage {...messages.nikeQuote} />,
    quotee: 'Nikki, 21',
    image: {
      src: nikeSmallImage,
    },
  },
  {
    heading: (
      <>
        <strong className="font-bold">
          -<FormattedWeight weightInKg={5} />
        </strong>{' '}
        <FormattedMessage {...messages.weeks} />
      </>
    ),
    quote: <FormattedMessage {...messages.nathalieQuote} />,
    quotee: 'Nathalie, 27',
    image: {
      src: nathalieSmallImage,
    },
  },
  {
    heading: (
      <>
        <strong className="font-black">
          -{<FormattedWeight weightInKg={6} />}
        </strong>{' '}
        <FormattedMessage {...messages.months} />
      </>
    ),
    quote: <FormattedMessage {...messages.marianneQuote} />,
    quotee: <FormattedMessage {...messages.marianneName} />,
    image: {
      src: marianneSmallImage,
    },
  },
]

type Props = {
  testimonials?: {
    heading: React.ReactNode
    quote: React.ReactNode
    quotee: React.ReactNode
    image: {
      src: string
      srcSet?: string
    }
  }[]
}

export default function Testimonials({
  testimonials = defaultTestimonials,
}: Props) {
  const mask = 'linear-gradient(rgb(0, 0, 0) 30%, rgba(0, 0, 0, 0))'

  return (
    <div>
      <h2 className="sr-only">Testimonials from some of our customers</h2>
      <Slideshow onInteraction={once(trackTestimonialInteraction)}>
        <Slides>
          {testimonials.map((testimonial, i) => (
            <Slide key={i}>
              <div
                className="relative flex h-full  flex-col justify-end overflow-hidden px-12 pb-24 text-center text-white lg:pb-40"
                style={{
                  paddingTop: '45%',
                  backgroundColor: '#262337',
                }}
              >
                <img
                  src={testimonial.image.src}
                  srcSet={testimonial.image.srcSet}
                  alt=""
                  className="absolute inset-0"
                  style={{
                    mask,
                    WebkitMask: mask,
                  }}
                />
                <div className="relative z-10">
                  <h3 className="mb-8 type-20-caps lg:type-24-caps xxl:type-28-caps">
                    {testimonial.heading}
                  </h3>
                  <blockquote>
                    <p className="mb-8 leading-body type-14 lg:type-17 xxl:type-20">
                      ”{testimonial.quote}”
                    </p>
                    <footer>
                      <cite className="type-12-demibold-caps lg:type-14-demibold-caps xxl:type-17-demibold-caps">
                        {testimonial.quotee}
                      </cite>
                    </footer>
                  </blockquote>
                </div>
              </div>
            </Slide>
          ))}
        </Slides>
        <SlideshowNav></SlideshowNav>
      </Slideshow>
    </div>
  )
}
